import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeveloperCard from "../common/DeveloperCard";
import CodingBackground from "../../assets/common/CodingBackground.png";
import DoubleStar from "../../assets/common/DoubleStar.svg";
import Image from "../../components/general/Image";
import DeveloperBannerImage from "../../assets/hire-developer/HireDeveloperHero.png";
import Button from "../../components/general/Button";
import TestimonialsImage from "../../assets/hire-developer/Testimonials.png";
import TestimonialsCard from "../../components/hire-developer/Testimonials";
import BackgroundImage from "../../assets/hire-developer/Background.png";
import { ROUTES } from "../../routes/RouteList";
import { useState } from "react";
const BannerSection = ({ selected_skill }) => {
    const backgroundStyles = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'contain',
        backgroundPosition: 'initial'
    }
    const navigate = useNavigate()
    const { developerListByRoleSkills } = useSelector(state => state.home);

    return (
        <section className="!py-[50px] lg:!py-[30px] relative" style={backgroundStyles}>
            <div className="--layout-padding max-width">
                <div className="text-white relative" style={{ zIndex: 1 }}>
                    <div className="flex flex-col-reverse lg:flex-row lg:justify-between items-start lg:gap-[20px]">
                        <div className="mb-[30px] lg:mb-[60px] lg:w-[55%]">
                            <h1 className="text-[35px] lg:text-[2.4rem] font-bold">
                                Hire {selected_skill}{' '}
                                <Image src={DoubleStar} alt="double-star" className="inline-block" />
                            </h1>
                            <p className="text-primary-color font-light lg:text-[1.1rem]">
                                Top Talent. Zero Hassle.
                            </p>
                            <p className="mt-[20px] font-light lg:text-[0.9rem]">
                                Skip the sourcing grind. Get 1–3 curated developers to <br className="hidden lg:block" /> interview — and onboard the right one in a week. <br className="hidden lg:block" /> Flexible hours and timezone overlap — built for your success.
                            </p>

                            <Button className="my-[20px] bg-primary-color text-black h-[40px] px-[20px] rounded-[5px] md:w-[250px] font-semibold lg:h-[50px] lg:px-[30px]" href={ROUTES.START_HIRING}>
                                Hire developers now <i className="fa-solid fa-arrow-up-right" />
                            </Button>

                            <ul className="mt-[30px] lg:mt-[60px] grid grid-cols-2 lg:grid-cols-3 gap-4 lg:mx-auto">
                                <div className="rounded-lg p-4 flex items-start justify-center flex-col gap-2 bg-[#1C1C1C]">
                                    <h5 className="text-primary-color font-semibold text-[20px]">1 in 40</h5>
                                    <div className="text-[11px] font-light">
                                        candidates approved after strict evaluation
                                    </div>
                                </div>
                                <div className="rounded-lg p-4 flex items-start justify-center flex-col gap-2 bg-[#1C1C1C]">
                                    <h5 className="text-primary-color font-semibold text-[20px]">98%</h5>
                                    <div className="text-[11px] font-light">
                                        first-match developer satisfaction rate
                                    </div>
                                </div>
                                <div className="rounded-lg p-4 flex items-start justify-center flex-col gap-2 bg-[#1C1C1C]">
                                    <h5 className="text-primary-color font-semibold text-[20px]"> {'< 24 hours'} </h5>
                                    <div className="text-[11px] font-light">
                                        zero downtime for scaling or replacements
                                    </div>
                                </div>
                            </ul>
                        </div>
                        <div className="lg:w-[50%]">
                            <Image className='w-full' src={DeveloperBannerImage} alt="developer-banner-image" />
                        </div> 
                    </div>
                    <DeveloperProfiles developers={developerListByRoleSkills} {...{ selected_skill, navigate }} />
                </div>
                {
                    developerListByRoleSkills.length > 0 && (
                        <Image src={BackgroundImage} alt="background-image" className="hidden lg:inline-block absolute bottom-[100px] left-0 w-[200px] object-cover z-0 " />
                    )
                }
            </div>
        </section>
    );
};

const DeveloperProfiles = ({ developers, selected_skill, navigate }) => {
    if (developers.length === 0) return null;
    return (
        <div className="">
            <h2 className="text-[25px] lg:text-[1.35rem] flex items-center lg:mb-[30px]">
                <span className="lg:w-[35%] mb-[20px] lg:mb-[0px]">
                    Hire remote {selected_skill}
                </span>
                <hr className="hidden lg:block w-[60%] border border-gray-500" />
            </h2>
            <div className="lg:flex lg:justify-between lg:items-start lg:gap-x-[70px]">
                <div className="developers">
                    <div className="flex flex-col gap-[30px] md:grid md:grid-cols-2 lg:gap-x-[20px]">
                        <DeveloperCard {...{ developers }} />
                    </div>
                    <div className="text-center my-[20px]">
                        <Button className="bg-primary-color text-black h-[40px] px-[20px] rounded-[5px] md:w-[280px] font-semibold lg:h-[50px] lg:px-[30px]" href={ROUTES.START_HIRING}>
                            Register to view more <i className="fa-solid fa-arrow-up-right" />
                        </Button>
                    </div>
                </div>
                <div className="lg:max-w-[40%]">
                    <Testimonials />
                </div>
            </div>
        </div>
    );
};

const Testimonials = () => {
    const [showAllTestimonials, setShowAllTestimonials] = useState(false)
    return (
        <div className="mt-[30px] lg:mt-[0px]">
            <h4 className="text-[#888888] mb-[20px] font-semibold text-[25px]">Built and battle-tested at:</h4>
            <div className="devlogos">
                <Image className='w-full' src={TestimonialsImage} alt="testimonials-image" />
            </div>
            <h4 className="text-[#888888] mb-[20px] font-semibold text-[25px] mt-[30px]">Testimonials</h4>
            <TestimonialsCard showAll={showAllTestimonials} />
            <div className="text-right mt-[30px]">
                <p onClick={() => setShowAllTestimonials(prev => !prev)} className="text-primary-color underline cursor-pointer">View {showAllTestimonials ? 'less' : 'more'} testimonials</p>
            </div>
        </div>
    );
};

export default BannerSection;